// extracted by mini-css-extract-plugin
module.exports = {"container":"RemoveExpirationActionButtons_container__Ihg2O","buttons":"RemoveExpirationActionButtons_buttons__28zDF"};